import { Flex, Form, Input, Switch, Tooltip } from "antd"
import { useTranslation } from "react-i18next"

import Images from "../../../../Images"

import styles from "./PromocodeField.module.less"

const PromocodeField = () => {
  const { t } = useTranslation()
  const enabled = Form.useWatch("promocode_enabled")

  const label = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%"
      }}
    >
      <Flex gap={"small"}>
        <span>
          {t("Promocode")}
          <span style={{ color: "red", fontSize: "11px", marginLeft: "2px" }}>*</span>
        </span>
        <Tooltip>{<img src={Images["info"]} alt="" />}</Tooltip>
      </Flex>
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          fontWeight: 400
        }}
      >
        <span style={{ fontSize: 12 }}>{t("Enabled")}</span>
        <Form.Item name="promocode_enabled" valuePropName="checked" noStyle>
          <Switch size="small" />
        </Form.Item>
      </span>
    </div>
  )

  return (
    <Form.Item
      name="promocode"
      label={label}
      required={false}
      className={styles.row}
      dependencies={["promocode_enabled"]}
      rules={[
        {
          required: enabled,
          whitespace: true,
          message: "This field is required"
        },
        { max: 150, message: t("The field cannot exceed 150 characters") }
      ]}
    >
      <Input
        placeholder="e.g. CHARGEBACK20"
        disabled={!enabled}
        data-testid="partner-modal-promocode-input"
      />
    </Form.Item>
  )
}

export default PromocodeField
